<template>
  <div v-if="visible" class="auth-modal-overlay" @click.self="handleModalClick">
    <div class="auth-modal">
      <div class="auth-modal__icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v4M12 16h.01" />
        </svg>
      </div>
      <h2 class="auth-modal__title">登录信息已失效</h2>
      <p class="auth-modal__message">{{ message || '您的登录信息已过期，请重新登录后继续使用' }}</p>
      <button class="btn btn--primary auth-modal__button" @click="$emit('relogin')">
        重新登录
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleModalClick() {
      // 阻止点击遮罩层关闭弹窗
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/tokens';

.auth-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.auth-modal {
  position: relative;
  width: 90%;
  max-width: 440px;
  padding: 40px 32px;
  background: $color-surface;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.auth-modal__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba($color-primary, 0.1) 0%, rgba($color-accent, 0.1) 100%);

  svg {
    color: $color-primary;
  }
}

.auth-modal__title {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 700;
  color: $color-text-primary;
}

.auth-modal__message {
  margin: 0 0 32px;
  font-size: 15px;
  line-height: 1.6;
  color: $color-text-secondary;
}

.auth-modal__button {
  width: 100%;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
}
</style>
